// import React from "react";
// import { AnouncementList } from "../../../data/AnouncementData";
// import {
//   Card,
//   CardLeft,
//   CardRight,
//   // TechCardContainer,
//   // TechCard,
//   BtnGroup,
// } from "./AnouncementCardElements";
// import ScrollAnimation from "react-animate-on-scroll";
// function AnouncementCard() {
//   return (
//     <>
//       {AnouncementList.map((list, index) => (
//         <ScrollAnimation animateIn="fadeInLeft" key={index}>
//           <Card>
//             <CardLeft>
//               {/* <img src={list.img} alt={list.name} /> */}
//             </CardLeft>
//             <CardRight>
//               <h4>{list.title}</h4>
//               <p>{list.description}</p>
//               {/* <TechCardContainer>
//                 {list.tech_stack.map((tech, index) => (
//                   <TechCard key={index}>{tech}</TechCard>
//                 ))}
//               </TechCardContainer> */}
//               <BtnGroup>
//                 {/* {list.github_url.length > 0 && (
//                   // <a
//                   //   className="btn SecondaryBtn btn-shadow"
//                   //   href={list.github_url}
//                   //   target="_blank"
//                   //   rel="noopener noreferrer"
//                   // >
//                   //   Github
//                   // </a>
//                 )
//                 } */}
//                 {list.demo_url.length > 0 && (
//                   <a
//                     className="btn PrimaryBtn btn-shadow"
//                     href={list.demo_url}
//                     target="_blank"
//                     rel="noopener noreferrer"
//                   >
//                     Read More ➜
//                   </a>
//                 )}
//               </BtnGroup>
//             </CardRight>
//           </Card>
//         </ScrollAnimation>
//       ))}
//     </>
//   );
// }

// export default AnouncementCard;
import React, { useEffect, useState } from 'react';
import { listAnnouncements } from '../../../services/contentService';
import {
  Card,
  CardLeft,
  CardRight,
  BtnGroup,
} from "./AnouncementCardElements";
import ScrollAnimation from "react-animate-on-scroll";

const AnouncementCard = () => {
  const [items, setItems] = useState([]);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    listAnnouncements()
      .then((rows) => {
        if (cancelled) return;
        setItems(rows);
      })
      .catch((e) => {
        if (cancelled) return;
        setError(e.message);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <>
      {error ? <div style={{ color: 'crimson' }}>{error}</div> : null}
      {items.map((it) => (
        <ScrollAnimation animateIn="fadeInLeft" key={it.id || `${it.title}-${it.url}`}>
          <Card>
            <CardLeft>
              {/* <img src={list.img} alt={list.name} /> */}
            </CardLeft>
            <CardRight>
              <h4>{it.title}</h4>
              {it.subtitle ? <div className="anouncement__card__subtitle">{it.subtitle}</div> : null}
              <BtnGroup>
                {it.url ? (
                  <a
                    className="btn PrimaryBtn btn-shadow"
                    href={it.url}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    View
                  </a>
                ) : null}
              </BtnGroup>
            </CardRight>
          </Card>
        </ScrollAnimation>
      ))}
      {items.length === 0 && !error ? <div style={{ opacity: 0.8 }}>No announcements available.</div> : null}
    </>
  );
};

export default AnouncementCard;
